import { CognitoUserPool } from "amazon-cognito-identity-js";
import { COGNITO_USER_POOL_ID, COGNITO_APP_CLIENT_ID } from "../../config";

interface props {
  UserPoolId: any;
  ClientId: any;
}
const poolData: props = {
  UserPoolId: COGNITO_USER_POOL_ID,
  ClientId: COGNITO_APP_CLIENT_ID,
};

export default new CognitoUserPool(poolData);
